module.exports = __webpack_public_path__ + "static/computer_vision-c44d3f31b03294ea0eceb5794e34f656.png";